import { CartDrawer } from "~/rs-components/global/CartDrawer.client"
import { contactInfo, header } from "../settings"
import PhoneHeader from "~/assets/icons/PhoneHeader";
import CartIcon from "~/assets/icons/CartIcon";
import FacebookIcon from "~/assets/icons/FacebookIcon";
import InstagramIcon from "~/assets/icons/InstagramIcon";
import LinkedinIcon from "~/assets/icons/LinkedinIcon";
import PinterestIcon from "~/assets/icons/PinterestIcon";
import TwitterIcon from "~/assets/icons/TwitterIcon";
import UserIcon from "~/assets/icons/UserIcon";
import YoutubeIcon from "~/assets/icons/YoutubeIcon";
import CartBadge from "~/rs-components/global/header/CartBadge.client";
import { Metafield } from "@shopify/hydrogen/storefront-api-types";
import TaglineComponent from "~/rs-components/global/header/Tagline.client";
import { isNonTransactional } from "../settings/__nonTransactional";
import BasketIcon from "../assets/basket";
import StoresIcon from "../assets/stores";
import LoginIcon from "../assets/login";
import { routeWishList, wishlistButtonNextTitle } from "../settings/__product";
import WishButtonIcon from "../custom_icons/WishButtonIcon";
import SearIcon from "~/assets/icons/SearchIcon";

interface SetupActivityBrandProp {
    isCartOpen: boolean;
    closeCart: () => void;
    openCart: () => void;
    currency: string;
    tagline?: Metafield;
}


export default function SetupActivityBar({ isCartOpen, closeCart, openCart, currency, tagline }: SetupActivityBrandProp) {

    return (
        <>
            <CartDrawer currency={currency} isOpen={isCartOpen} onClose={closeCart} />
            {header.activityBar.show &&
                <div className="NotificationPromo">
                    <div className="NotificationPromo__container">
                        {header.activityBar.show &&
                            <div className="NotificationPromo">
                                <div className="NotificationPromo__container">
                                    <TaglineComponent tagline={tagline} />
                                    <div className="NotificationPromo__user">
                                        <div className="iconArea">

                                            <div className="topUserArea loginCart lineRight">
                                                <div className="topUserArea__search-container">
                                                    <div className="topUserArea__search">
                                                        <form action={`/products`} method="GET">
                                                            <input name="search" type="search" placeholder="Search..." />
                                                            <i className="fa">
                                                                <button type='submit' className='buttonSearch'><SearIcon /></button>
                                                            </i>
                                                        </form>
                                                    </div>
                                                </div>
                                                <p>Search</p>
                                            </div>

                                            {wishlistButtonNextTitle &&
                                                <div className="">
                                                    <a className="iconItem lineRight" href={routeWishList}><WishButtonIcon />Wish</a>
                                                </div>
                                            }

                                            <a href="/account" className="iconItem lineRight">
                                                <LoginIcon></LoginIcon>
                                                LogIn
                                            </a>

                                            <a href="/page/store-locator" className="iconItem lineRight">
                                                <StoresIcon></StoresIcon>
                                                Stores
                                            </a>

                                            <div className="cartArea">
                                                {!isNonTransactional &&
                                                    <button onClick={openCart} className='cartIcon relative flex items-center justify-center w-8 h-8'>
                                                        <div className="basket">
                                                            <BasketIcon />
                                                            <CartBadge />
                                                        </div>
                                                        <p>Basket</p>
                                                    </button>}

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </>

    )
}